import {
  $convertFromMarkdownString,
  TextMatchTransformer,
  TRANSFORMERS,
} from '@lexical/markdown';
import { $createLineBreakNode, $createTextNode, LineBreakNode } from 'lexical';
import { $createParagraphNode, $getRoot } from 'lexical';
import { LexicalEditor } from 'lexical';
import { traceError } from '@/utils/trace-error';

const BR: TextMatchTransformer = {
  dependencies: [LineBreakNode],
  export: () => {
    return null;
  },
  importRegExp: /<br\s?\/?>/,
  regExp: /<br\s?\/?>/,
  replace: (textNode) => {
    const parentNode = textNode.getParent();
    if (parentNode?.getChildrenSize() === 1) {
      textNode.remove();
    } else {
      textNode.replace($createLineBreakNode());
    }
  },
  trigger: '',
  type: 'text-match',
};

export const $prepopulateJson = (
  editor: LexicalEditor,
  initialState: string,
  format: 'json' | 'md',
) => {
  try {
    if (format === 'json' && initialState.startsWith('{')) {
      const parsed = editor.parseEditorState(initialState);
      editor.setEditorState(parsed);
      return;
    } else if (format === 'md') {
      $convertFromMarkdownString(initialState, TRANSFORMERS.concat(BR));
      return;
    }
  } catch (err) {
    traceError(
      new Error("Failed to parse text editor's state", { cause: err }),
    );
  }
  const root = $getRoot();
  const p = $createParagraphNode();
  const textNode = $createTextNode(initialState);
  p.append(textNode);
  root.append(p);
};
